/**
 * 用户API
 * 用户API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import LoginSuccessDto from '../../user/model/LoginSuccessDto';
import UserForm from '../../user/model/UserForm';
import WechatCode from '../../user/model/WechatCode';
  /**
   * User service.
   * @module user/api/UserApi
   * @version 0.2.0
   */

  /**
   * Constructs a new UserApi. 
   * @alias module:user/api/UserApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 使用code登录
     * @param {module:user/model/WechatCode} body 微信code
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/LoginSuccessDto}
     */
    this.login = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling login";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = LoginSuccessDto;

      return this.apiClient.callApi(
        '/api/user/login', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, false
      );
    }


    /**
     * 注册
     * @param {module:user/model/UserForm} body 微信code
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/LoginSuccessDto}
     */
    this.update = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling update";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = LoginSuccessDto;

      return this.apiClient.callApi(
        '/api/user/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, false
      );
    }
  };

  export default exports;
